import { type FC } from 'react';

import { mergeSx } from '../../../util/mui/sx';

import {
  GenericListItemCheckbox,
  type GenericListItemCheckboxProps,
} from './GenericListItemCheckbox';

export interface GenericMenuItemCheckboxProps extends GenericListItemCheckboxProps {}

export const GenericMenuItemCheckbox: FC<GenericMenuItemCheckboxProps> = props => (
  <GenericListItemCheckbox
    {...props}
    /* Setting `aria-hidden: true` and `tabIndex: -1` is not sufficient to prevent screen readers
       from accessing the checkbox. We need to take another pass at how the checkbox presentation is
       handled here, as using an actual input[type="checkbox"] element is introducing problems. This
       works in most practical cases, but fails WCAG 2.1. */
    inputProps={{
      ...props.inputProps,
      'aria-hidden': true,
      tabIndex: -1,
    }}
    sx={mergeSx({ padding: t => t.spacing(0.75) }, props.sx)}
  />
);
